<div class="lg:table-cell py-1 lg:py-5 px-2">
    <div class="text-xs font-semibold lg:hidden">{{ 'expirations_table_emit' | translate }}:</div>
    <ng-container *ngIf="item.fechaEmisionDocumento">
        {{ item.fechaEmisionDocumento | moment: 'DD/MM/YYYY' }}
    </ng-container>
    <ng-container *ngIf="!item.fechaEmisionDocumento">
        -
    </ng-container>
</div>
<div class="lg:table-cell py-1 lg:py-5 px-2">
    <div class="text-xs font-semibold lg:hidden">{{ 'expirations_table_num' | translate }}:</div>
        {{ item.factura }}
</div>
<div class="lg:table-cell py-1 lg:py-5 px-2">
    <div class="text-xs font-semibold lg:hidden">{{ 'expirations_table_date' | translate }}:</div>
    <ng-container *ngIf="item.vencimientoDate">
    {{ item.vencimientoDate | moment: 'DD/MM/YYYY' }}
    </ng-container>
    <ng-container *ngIf="!item.vencimientoDate">
        -
    </ng-container>
</div>
<div class="lg:table-cell py-1 lg:py-5 px-2">
    <div class="text-xs font-semibold lg:hidden">{{ 'expirations_table_tipo' | translate }}:</div>
    {{ item.claveCarteraNombre }}
</div>
<div class="lg:table-cell py-1 lg:py-5 px-2 lg:text-right">
    <div class="text-xs font-semibold lg:hidden">{{ 'expirations_table_price' | translate }}:</div>
    {{ item.importe | currency:(us.currency$ | async):'symbol':'1.2-2' }}
</div>

